<template>
  <v-flex>
    <v-card>
      <v-img :src="getBackgroundImg" height="70px">
      </v-img>
      <v-card-text>
        <v-avatar size="57" class="white mt-n12 elevation-3">
          <v-avatar size="55" class="grey">
            <v-img :src="summary.publicProfilePicture"></v-img>
          </v-avatar>
        </v-avatar>

        <v-row no-gutters>
          <v-col md="7" lg="7" sm="12" cols="12">
            <v-card-title class="pt-2 pl-0">
              {{summary.name}}
              <highlight-change v-if="deltaSection" :delta-value="deltaSection.name"></highlight-change>
            </v-card-title>
            <v-card-subtitle class="pa-0">
              {{summary.currentJob}}
              <highlight-change v-if="deltaSection" :delta-value="deltaSection.currentJob"></highlight-change>
            </v-card-subtitle>
            <v-card-subtitle class="pa-0 subtitle-2 font-weight-regular">
              <v-row no-gutters>
                <v-col>
                  {{summary.location}}
                  <highlight-change v-if="deltaSection" :delta-value="deltaSection.location"></highlight-change>
                </v-col>
                <v-col cols="4">
                  · {{getContacts}}
                  <highlight-change class="ml-2" style="width:auto" v-if="deltaSection" :delta-value="deltaSection.contactNumber"></highlight-change>
                </v-col>
              </v-row>
            </v-card-subtitle>
          </v-col>
          <v-col sm="12" cols="12">
            <v-list class="py-0">
              <v-list-item v-if="summary.company">
                <v-list-item-avatar tile size="30" class="my-2 grey"></v-list-item-avatar>
                <v-list-item-content class="light-blue--text py-3">
                  {{summary.company.name}}
                  <highlight-change v-if="deltaSection && deltaSection.company" :delta-value="deltaSection.company.name"></highlight-change>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="summary.school">
                <v-list-item-avatar tile size="30" class="my-2 grey"></v-list-item-avatar>
                <v-list-item-content class="light-blue--text py-3">
                  {{summary.school.name}}
                  <highlight-change v-if="deltaSection && deltaSection.school" :delta-value="deltaSection.school.name"></highlight-change>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mt-2" flat v-if="summary.description">
      <v-card-title class="pt-1 headline font-weight-regular">
        About
      </v-card-title>
      <v-card-text>
        <show-more-less :text="summary.description"></show-more-less>
        <highlight-change v-if="deltaSection" :delta-value="deltaSection.description"></highlight-change>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>

    import ShowMoreLess from "../../Widgets/showMoreLess";
    import HighlightChange from "../../Widgets/highlightChange";
    export default {
      name: "summaryMocker",
      components: {HighlightChange, ShowMoreLess},
      props: ['summary', 'deltaSection'],
      computed: {
        getBackgroundImg() {
          // return this.summary.backgroundImage ? this.summary.backgroundImage : '/static/linBackground.svg'
          return '/static/linBackground.svg'
        },
        getContacts() {
          let contactString = `${parseInt(this.summary.contactNumber)} contacts`;
          return this.summary.contactNumber === 500 ? `+${contactString}`:contactString;
        },
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mockers/Lin/summaryMocker.vue